import React, {useMemo} from 'react';
import type {ButtonProps} from '@mui/material';
import type {IconName} from 'components/icons/types';
import {useLocalization} from 'localization';
import {ActionButtonV2} from 'components/button/ActionButtonV2';
import type {SelectAction} from '../../editThesaurus/types';

type Props = {
  nodeId: string;
  action: SelectAction | undefined;
  addNodeId: (nodeId: string) => void;
  removeNodeId: (nodeId: string) => void;
};

export const SearchMatchAction: React.FC<Props> = ({
  nodeId,
  action,
  addNodeId,
  removeNodeId,
}) => {
  const {tLoose} = useLocalization();
  const {actionTitle, actionIcon, actionColor, onAction} = useMemo(() => {
    const actionType = action?.type ?? 'select';
    const actionTitle = tLoose(`extension.thesaurusEdit.${actionType}`);
    const actionIcon: IconName =
      actionType === 'select'
        ? 'Check'
        : actionType === 'swap'
          ? 'Swap'
          : 'Remove';
    const actionColor: ButtonProps['color'] =
      actionType === 'select' ? 'primary' : 'secondary';
    return {
      nodeId,
      actionTitle,
      actionIcon,
      actionColor,
      onAction: () =>
        actionType === 'remove' ? removeNodeId(nodeId) : addNodeId(nodeId),
    };
  }, [action?.type, addNodeId, nodeId, removeNodeId, tLoose]);

  return (
    <ActionButtonV2
      title={actionTitle}
      icon={actionIcon}
      size="small"
      color={actionColor}
      showSpinnerOnClick
      onClick={onAction}
    />
  );
};
